import { View, type ViewProps } from "react-native"
import React, { forwardRef, type ReactNode } from "react"
import { cn } from "@/components/util/cn"

interface BFLayoutProps extends ViewProps {
  children: ReactNode
  fullscreen?: boolean
  variant: keyof typeof BFLayoutVariants
}

const BFLayoutVariants = {
  vertical: "flex flex-col",
  horizontal: "flex flex-row",
  center: "flex flex-row justify-center items-center",
}

export const BFLayout = ({
  children,
  className,
  variant,
  fullscreen,
  ...rest
}: BFLayoutProps) => {
  return (
    <View
      className={cn(
        BFLayoutVariants[variant],
        fullscreen && "absolute inset-0",
        className
      )}
      {...rest}
    >
      {children}
    </View>
  )
}

type NoVariantLayoutProps = Omit<BFLayoutProps, "variant">

export const Vertical = forwardRef<typeof BFLayout, NoVariantLayoutProps>(
  (props, _ref) => {
    return <BFLayout variant="vertical" {...props} />
  }
)

export const Horizontal = forwardRef<typeof View, NoVariantLayoutProps>(
  (props, _ref) => {
    return <BFLayout variant="horizontal" {...props} />
  }
)

export const Center = forwardRef<typeof BFLayout, NoVariantLayoutProps>(
  (props, _ref) => {
    return <BFLayout variant="center" {...props} />
  }
)
